import { create } from "zustand";
import { axiosInstance } from "../lib/axios";
import toast from "react-hot-toast";
import { useAuthStore } from "./useAuthStore";

export const useWalletStore = create((set, get) => ({
  balance: 0,
  transactions: [],
  isWalletLoading: false,
  isTipping: false,
  isClaimingReward: false,

  fetchWalletData: async () => {
    set({ isWalletLoading: true });
    try {
      const res = await axiosInstance.get("/wallet");
      set({ balance: res.data.balance, transactions: res.data.transactions });
      // Sync auth user points
      const authUser = useAuthStore.getState().authUser;
      if (authUser) {
        useAuthStore.setState({ authUser: { ...authUser, points: res.data.balance } });
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to fetch wallet data");
    } finally {
      set({ isWalletLoading: false });
    }
  },

  sendTip: async (receiverId, amount, message) => {
    set({ isTipping: true });
    try {
      const res = await axiosInstance.post("/wallet/tip", { receiverId, amount, message });
      set({ balance: res.data.newBalance });
      // Sync auth user points
      const authUser = useAuthStore.getState().authUser;
      if (authUser) {
        useAuthStore.setState({ authUser: { ...authUser, points: res.data.newBalance } });
      }
      toast.success(res.data.message);
      // Refresh transactions if on wallet page
      get().fetchWalletData();
      return true;
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to send tip");
      return false;
    } finally {
      set({ isTipping: false });
    }
  },

  claimDailyReward: async () => {
    set({ isClaimingReward: true });
    try {
      const res = await axiosInstance.post("/wallet/daily-reward");
      set({ balance: res.data.newBalance });
      // Sync auth user points
      const authUser = useAuthStore.getState().authUser;
      if (authUser) {
        useAuthStore.setState({ authUser: { ...authUser, points: res.data.newBalance } });
      }
      toast.success(res.data.message, {
        icon: '🎁',
        style: {
          borderRadius: '10px',
          background: '#333',
          color: '#fff',
        },
      });
      // Refresh transactions
      get().fetchWalletData();
      return true;
    } catch (error) {
      toast.error(error.response?.data?.message || "Already claimed today!");
      return false;
    } finally {
      set({ isClaimingReward: false });
    }
  },

  subscribeToWalletEvents: () => {
    const socket = useAuthStore.getState().socket;
    if (!socket) return;
    
    socket.on("tipReceived", (data) => {
      toast.success(`${data.senderName} just sent you a gift of ${data.amount} CS! 🎁\n"${data.message}"`, {
        duration: 6000,
        style: {
          border: '1px solid #713200',
          padding: '16px',
          color: '#713200',
        },
        iconTheme: {
          primary: '#713200',
          secondary: '#FFFAEE',
        },
      });
      get().fetchWalletData();
    });
  },

  unsubscribeFromWalletEvents: () => {
    const socket = useAuthStore.getState().socket;
    if (!socket) return;
    socket.off("tipReceived");
  },
}));
